module.exports = __webpack_public_path__ + "img/cpp.bbb8a228.png";